// Finance build (Workstream E) — query-key factory for the cross-loan Loan
// Payments ledger. queryKey arrays live ONLY in *Keys files (stale-after-save
// convention).

import type { LoanPaymentsLedgerParams } from "@/api/portfolioAdmin/loanPaymentsApi";

export const loanPaymentsKeys = {
  ledger: (params?: LoanPaymentsLedgerParams) =>
    ["portfolio-admin", "loan-payments", params ?? {}] as const,
};
